
export interface HashtagResponse {
  id?: string;
  name?: string;
  tweetCount?: number;
}
